export class ContactsConfig{
	DefaultPaymentDays:number = 0;
	DefaultDiscountCashDays:number = 8;
	DefaultCountry:string = "BE";
	CheckForDuplicateAddress:boolean = false;
	AutoCompleteContactAddress:boolean = false;
	ContactSelectVatID:boolean = false;
	DefaultSellPriceCategoryForNewClients:number = 0;
	FostplusCheckExtraField:string = "";
	ShowBankOnContact:boolean = false;

	public constructor(data:any){
		this.DefaultPaymentDays = data.DefaultPaymentDays;
		this.DefaultDiscountCashDays = data.DefaultDiscountCashDays == undefined ? 8 : data.DefaultDiscountCashDays;
		this.DefaultCountry = data.DefaultCountry || "BE";
		this.CheckForDuplicateAddress = data.CheckForDuplicateAddress || false;
		this.ContactSelectVatID = data.ContactSelectVatID || false;
		this.DefaultSellPriceCategoryForNewClients = data.DefaultSellPriceCategoryForNewClients || 0;
		this.FostplusCheckExtraField = data.FostplusCheckExtraField || "";
		this.AutoCompleteContactAddress = data.AutoCompleteContactAddress;
		this.ShowBankOnContact = data.ShowBankOnContact || false;
	}

	public getJSON(){
		return {
			DefaultPaymentDays: this.DefaultPaymentDays,
			DefaultDiscountCashDays: this.DefaultDiscountCashDays,
			DefaultCountry: this.DefaultCountry,
			CheckForDuplicateAddress: this.CheckForDuplicateAddress,
			ContactSelectVatID: this.ContactSelectVatID,
			DefaultSellPriceCategoryForNewClients: this.DefaultSellPriceCategoryForNewClients,
			FostplusCheckExtraField: this.FostplusCheckExtraField,
			AutoCompleteContactAddress: this.AutoCompleteContactAddress,
			ShowBankOnContact: this.ShowBankOnContact
		};
	}
}